export default function useHandleError (e: any) {
  const { $i18n } = useNuxtApp(); // https://projects.olc.cz/issues/99645
  const { notify } = useNotification();
  notify({
    title: $i18n.t("form.common.error"), // https://projects.olc.cz/issues/99645
    text: e.data?.detail ?? "",
    type: "error"
  });
}
